import {object, string, z} from 'zod'

export const VazhipaduFormSchema = object({
    ServiceId: string().refine(value => value, {
        message: 'Service id should be a required field!'
    }),
    Quantity: string().refine(value => value, {
        message: 'Quantity should not be an empty field!'
    })
})